import { useReducer } from 'react';

export type PostingMethodTypes = 'EXTERNAL_APP' | 'SHIPPING_LABEL';
export type PostingMethodAction =
  | { type: 'UPDATE'; payload: PostingMethodTypes }
  | { type: 'ERROR' };
export type PostingMethodState = 'init' | 'error' | 'success';

export interface PostingMethodsStoreError {
  postingMethod: '';
  status: 'error';
}

export interface PostingMethodsStoreValid {
  postingMethod: PostingMethodTypes;
  status: 'success';
}

export interface PostingMethodsStoreInit {
  postingMethod: '';
  status: 'init';
}

export type PostingMethodsStore =
  | PostingMethodsStoreError
  | PostingMethodsStoreValid
  | PostingMethodsStoreInit;

const INITIAL_STATE: PostingMethodsStore = {
  postingMethod: '',
  status: 'init',
};

const postingMethodsReducer = (
  state: PostingMethodsStore,
  action: PostingMethodAction,
): PostingMethodsStore => {
  switch (action.type) {
  case 'UPDATE':
    return {
      postingMethod: action.payload,
      status: 'success',
    };
  case 'ERROR':
    return {
      postingMethod: '',
      status: 'error',
    };
  default:
    return state;
  }
};

export const usePostingMethodReducer = (initialState = INITIAL_STATE) => {
  const [state, dispatch] = useReducer(postingMethodsReducer, initialState);

  return { state, dispatch };
};
